
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c6u22", function(module, exports) {

$parcel$export(module.exports, "ExcerptInclude", () => $c6f28e626bacffe3$export$f31130fd0c7ad090);

var $gwFzn = parcelRequire("gwFzn");

var $bDAHn = parcelRequire("bDAHn");

var $fuFnF = parcelRequire("fuFnF");

var $bFHEt = parcelRequire("bFHEt");
const $c6f28e626bacffe3$export$f31130fd0c7ad090 = (props)=>{
    const { isProviderAvailable: isProviderAvailable, addKey: addKey, hasKey: hasKey, removeKey: removeKey } = (0, $bDAHn.useRecursiveExcerptContext)();
    const [circularReferenceDetected, setCircularReferenceDetected] = (0, $gwFzn.useState)(undefined);
    const excerptPageTitle = props?.macroNode?.parameters?.macroParams?.['']?.value;
    const excerptName = props?.macroNode?.parameters?.macroParams?.name?.value ?? 'UNDEFINED_EXCERPT_NAME';
    const excerptKeyFromMacroParams = excerptPageTitle !== undefined ? `${excerptPageTitle}-${excerptName}` : undefined;
    (0, $gwFzn.useEffect)(()=>{
        if (!excerptKeyFromMacroParams || !isProviderAvailable) return;
        let didAdd = false;
        if (hasKey(excerptKeyFromMacroParams)) // If the key already exists, we must be in a loop.
        // The key shouldn't change for an already-rendered excerpt, so
        // this effect shouldn't fire again except for new excerpts.
        setCircularReferenceDetected(true);
        else {
            // The first time we see the key, add it.
            setCircularReferenceDetected(false);
            addKey(excerptKeyFromMacroParams);
            didAdd = true;
        }
        return ()=>{
            if (didAdd) removeKey(excerptKeyFromMacroParams);
        };
    }, [
        excerptKeyFromMacroParams,
        isProviderAvailable,
        hasKey,
        addKey,
        removeKey
    ]);
    if (!isProviderAvailable) // The top-most excerpt-include will provide the first excerpt key.
    // Child excerpt-includes will add their keys via the `addKey` function.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bDAHn.RecursiveExcerptContextProvider), {
        excerptKey: excerptKeyFromMacroParams
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bFHEt.ExcerptIncludeImpl), props));
    else if (circularReferenceDetected === undefined) return null;
    else if (circularReferenceDetected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuFnF.RecursiveExcerptError), null);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bFHEt.ExcerptIncludeImpl), props);
};

});
parcelRegister("bDAHn", function(module, exports) {

$parcel$export(module.exports, "RecursiveExcerptContextProvider", () => $e77954c2fac8bb43$export$8fbc0efd03a015e);
$parcel$export(module.exports, "useRecursiveExcerptContext", () => $e77954c2fac8bb43$export$3f68eeb1746e8c90);

var $gwFzn = parcelRequire("gwFzn");
const $e77954c2fac8bb43$var$RecursiveExcerptContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    hasKey: ()=>false,
    addKey: ()=>{},
    removeKey: ()=>{},
    isProviderAvailable: false
});
const $e77954c2fac8bb43$export$8fbc0efd03a015e = ({ children: children, excerptKey: excerptKey })=>{
    const keys = (0, $gwFzn.useMemo)(()=>{
        return new Set();
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (excerptKey) keys.add(excerptKey);
    }, [
        keys,
        excerptKey
    ]);
    const hasKey = (0, $gwFzn.useCallback)((key)=>{
        return keys.has(key);
    }, [
        keys
    ]);
    const addKey = (0, $gwFzn.useCallback)((key)=>{
        keys.add(key);
    }, [
        keys
    ]);
    const removeKey = (0, $gwFzn.useCallback)((key)=>{
        keys.delete(key);
    }, [
        keys
    ]);
    const contextValue = (0, $gwFzn.useMemo)(()=>{
        return {
            hasKey: hasKey,
            addKey: addKey,
            removeKey: removeKey,
            isProviderAvailable: true
        };
    }, [
        hasKey,
        addKey,
        removeKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e77954c2fac8bb43$var$RecursiveExcerptContext.Provider, {
        value: contextValue
    }, children);
};
const $e77954c2fac8bb43$export$3f68eeb1746e8c90 = ()=>(0, $gwFzn.useContext)($e77954c2fac8bb43$var$RecursiveExcerptContext);

});

parcelRegister("fuFnF", function(module, exports) {

$parcel$export(module.exports, "RecursiveExcerptError", () => $0f05f8ec17df934b$export$6990faa355fa7d3);

var $5dK2X = parcelRequire("5dK2X");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $aoVih = parcelRequire("aoVih");
const $0f05f8ec17df934b$var$i18n = (0, $2nPZH.defineMessages)({
    errorDescription: {
        id: "excerpt-include.recursive-error.description",
        defaultMessage: "This insert excerpt macro cannot insert an excerpt that it is nested within."
    }
});
const $0f05f8ec17df934b$export$6990faa355fa7d3 = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        as: "p"
    }, intl.formatMessage($0f05f8ec17df934b$var$i18n.errorDescription)));
};

});
parcelRegister("aoVih", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50f000c6973458a$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7hXDW = parcelRequire("7hXDW");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");

var $f6ZB3 = parcelRequire("f6ZB3");
const $e50f000c6973458a$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $e50f000c6973458a$var$SectionMessage = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $f6ZB3.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        as: "section",
        backgroundColor: $e50f000c6973458a$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $e50f000c6973458a$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $e50f000c6973458a$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            xcss: $e50f000c6973458a$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $dh538.fg)('platform_ads_explicit_font_styles') && $e50f000c6973458a$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $e50f000c6973458a$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$e50f000c6973458a$var$SectionMessage.displayName = 'SectionMessage';
var $e50f000c6973458a$export$2e2bcd8739ae039 = $e50f000c6973458a$var$SectionMessage;

});
parcelRegister("f6ZB3", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $3cc44aa8b598788e$export$e9b82d2e21ac0c1f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5L38b = parcelRequire("5L38b");

var $lpHGz = parcelRequire("lpHGz");

var $195qZ = parcelRequire("195qZ");

var $bAfMd = parcelRequire("bAfMd");

var $6hqEj = parcelRequire("6hqEj");

var $6fnsQ = parcelRequire("6fnsQ");
const $3cc44aa8b598788e$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $6fnsQ.B50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lpHGz))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $6fnsQ.B500)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $6fnsQ.Y50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($6hqEj))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $6fnsQ.Y500)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $6fnsQ.R50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5L38b))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $6fnsQ.R500)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $6fnsQ.G50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bAfMd))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $6fnsQ.G500)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $6fnsQ.P50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($195qZ))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $6fnsQ.P500)})`
    }
};
function $3cc44aa8b598788e$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $3cc44aa8b598788e$var$appearanceIconSchema[appearance] || $3cc44aa8b598788e$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $7UHDa.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});



parcelRegister("bFHEt", function(module, exports) {

$parcel$export(module.exports, "ExcerptIncludeImpl", () => $a28c11b9954ec4f2$export$358a2d09bf0dde5a);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $aTqya = parcelRequire("aTqya");

var $5kjCz = parcelRequire("5kjCz");
var $hUS75 = parcelRequire("hUS75");

var $iocv0 = parcelRequire("iocv0");

var $f9KPY = parcelRequire("f9KPY");

var $1e5Hj = parcelRequire("1e5Hj");

var $47eY7 = parcelRequire("47eY7");

var $5TYcG = parcelRequire("5TYcG");
const $a28c11b9954ec4f2$export$358a2d09bf0dde5a = ({ contentId: contentId, spaceKey: spaceKey, extensionKey: extensionKey, macroNode: macroNode, mode: mode, RendererWrapper: RendererWrapper, isLegacyRenderer: isLegacyRenderer, isLivePage: isLivePage })=>{
    const { extensionType: extensionType, parameters: { macroMetadata: macroMetadata, macroParams: macroParams, macroOutput: macroOutput, mediaToken: mediaToken }, type: type } = macroNode;
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(macroNode);
    const adfFromMacroOutput = (0, $gwFzn.useMemo)(()=>(0, $5TYcG.parseMacroOutputAdf)(macroOutput)?.content, [
        macroOutput
    ]);
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $47eY7.ExcerptIncludeQuery), {
        variables: {
            contentId: contentId,
            macroNode: {
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: {
                    macroMetadata: JSON.stringify(macroMetadata),
                    macroParams: JSON.stringify(macroParams)
                },
                type: type
            }
        },
        // Avoid to do a query if content already provided in `macroOutput` param
        skip: !!adfFromMacroOutput
    });
    const targetContentTitle = (0, $5TYcG.getMacroParam)(macroNode, '') || '';
    const shouldPanelBeDisplayed = (0, $5TYcG.getMacroParam)(macroNode, 'nopanel') !== 'true';
    const displayInline = (0, $5TYcG.getMacroParam)(macroNode, 'inline') === 'true';
    const excerptName = (0, $5TYcG.getMacroParam)(macroNode, 'name');
    const macroId = (0, $5TYcG.getMacroId)(macroNode);
    const targetContentId = data?.experimentalMacroMetadata?.contentId || (0, $5TYcG.getMacroParam)(macroNode, '_parentId') || contentId || '';
    const props = {
        RendererWrapper: RendererWrapper,
        extensionKey: extensionKey,
        macroNode: macroNode,
        mode: mode,
        pageId: contentId,
        spaceKey: spaceKey,
        shouldPanelBeDisplayed: shouldPanelBeDisplayed,
        displayInline: displayInline,
        excerptName: excerptName,
        targetContentTitle: targetContentTitle,
        macroId: macroId,
        isLegacyRenderer: isLegacyRenderer,
        isLivePage: isLivePage
    };
    if (adfFromMacroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iocv0.ExcerptIncludeComponent), {
        ...props,
        adf: adfFromMacroOutput,
        contentId: targetContentId,
        mediaToken: mediaToken
    });
    // This point will be reached if macroOutput param does not contain target excerpt data.
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f9KPY.ExcerptIncludeComponentShadow), {
        shouldPanelBeDisplayed: shouldPanelBeDisplayed,
        targetContentTitle: targetContentTitle
    });
    const adfString = data?.experimentalMacroMetadata?.payload;
    if (error) {
        const queryError = error || new (0, $aTqya.ApolloError)({
            errorMessage: `${extensionKey} failed to render because macro metadata payload is empty`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hUS75.MacroExperienceStop), {
            error: queryError,
            mode: mode,
            name: (0, $5kjCz.getExperienceName)(mode, macroNode),
            attributes: attributes,
            contentId: contentId,
            source: "ExcerptIncludeImpl"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1e5Hj.ExcerptIncludeError), {
            targetContentTitle: targetContentTitle
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iocv0.ExcerptIncludeComponent), {
        ...props,
        adf: adfString ? JSON.parse(adfString) : undefined,
        contentId: targetContentId
    });
};

});
parcelRegister("iocv0", function(module, exports) {

$parcel$export(module.exports, "ExcerptIncludeComponent", () => $5942172932878591$export$1980ed6e948b49ee);
/* ExcerptIncludeComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $1Zr9M = parcelRequire("1Zr9M");

var $5LTS4 = parcelRequire("5LTS4");
var $kksmx = parcelRequire("kksmx");

var $5kjCz = parcelRequire("5kjCz");
var $bX5uj = parcelRequire("bX5uj");

var $dhEYL = parcelRequire("dhEYL");

var $f7tsL = parcelRequire("f7tsL");
class $5942172932878591$var$ExcerptIncludeRendererComponent extends (0, $gwFzn.Component) {
    render() {
        const { adf: adf, contentId: contentId, pageId: pageId, shouldPanelBeDisplayed: shouldPanelBeDisplayed, excerptName: excerptName, targetContentTitle: targetContentTitle, mode: mode, extensionKey: extensionKey, macroNode: macroNode, macroId: macroId, RendererWrapper: RendererWrapper, isLegacyRenderer: isLegacyRenderer, mediaToken: mediaToken, isLivePage: isLivePage, intl: intl } = this.props;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(macroNode); /**
                                                                  * Returns true if:
                                                                  * - ADF is non null AND
                                                                  * - IF excerpt is untitled, that its content is not empty
                                                                  * This is because the renderer can return empty ADF for null excerpts
                                                                  */ 
        const hasExcerpt = ()=>{
            const emptyAdf = [
                {
                    type: 'paragraph'
                }
            ];
            return !!adf && (!!excerptName || JSON.stringify(adf) !== JSON.stringify(emptyAdf));
        };
        const excerptIncludeStyle = null;
        const getExcerptBody = ()=>{
            return !hasExcerpt() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5942172932878591$var$ExcerptIncludeEmpty, {
                mode: mode,
                shouldPanelBeDisplayed: shouldPanelBeDisplayed,
                isLivePage: isLivePage,
                intl: intl
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(RendererWrapper, {
                adf: adf,
                targetContentId: contentId,
                mediaToken: mediaToken,
                isInsideOfInlineExtension: !shouldPanelBeDisplayed
            });
        }; // WS-2563 Adding class to Excerpt Include HTML so it can be excluded from highlights
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            "data-fabric-macro": macroId,
            className: (0, $35pXk.default)([
                "_1ul9idpf",
                "ak-excerpt-include ak-renderer-extension"
            ]),
            "data-testid": "excerpt-include-component" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        }, isLegacyRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
            contentId: pageId,
            extensionKey: extensionKey,
            node: macroNode
        }), shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle, hasExcerpt() && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: (0, $dhEYL.panelHeaderExcerpt)
        }, "| ", excerptName ?? intl.formatMessage((0, $f7tsL.i18n).untitledExcerpt))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, getExcerptBody())) : getExcerptBody(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kksmx.ExtensionSSRMark), {
            macroId: macroId,
            renderType: "ssr-new"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            contentId: pageId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            name: (0, $5kjCz.getExperienceName)(mode, macroNode)
        }));
    }
}
class $5942172932878591$var$ExcerptIncludeEmpty extends (0, $gwFzn.Component) {
    render() {
        const { mode: mode, shouldPanelBeDisplayed: shouldPanelBeDisplayed, isLivePage: isLivePage, intl: intl } = this.props;
        const emptyContentStyle = null;
        return (shouldPanelBeDisplayed || mode === 'editor' && !isLivePage) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            className: (0, $35pXk.default)([
                "_1yt41b66 _1e0c1txw _4cvr1h6o _syaz1gjq"
            ])
        }, intl.formatMessage((0, $f7tsL.i18n).emptyMacro), mode === 'editor' && !isLivePage && intl.formatMessage((0, $f7tsL.i18n).emptyMacroEdit, {
            editIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                label: "edit",
                color: "var(--ds-icon, #44546F)"
            })
        }));
    }
}
const $5942172932878591$export$1980ed6e948b49ee = (0, $js7oX.default)($5942172932878591$var$ExcerptIncludeRendererComponent);

});
parcelRegister("f7tsL", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $586bbeb50503c018$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $586bbeb50503c018$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    emptyMacro: {
        id: "excerpt-include.empty",
        defaultMessage: "No excerpts found."
    },
    emptyMacroEdit: {
        id: "excerpt-include.empty.edit",
        defaultMessage: "Select{editIcon}to choose a different source page."
    },
    untitledExcerpt: {
        id: "excerpt-include.untitled",
        defaultMessage: "Untitled excerpt"
    }
});

});


parcelRegister("1e5Hj", function(module, exports) {

$parcel$export(module.exports, "ExcerptIncludeError", () => $6d5b4820d47006ab$export$9959a21ec1aff866);

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $2p7B1 = parcelRequire("2p7B1");
class $6d5b4820d47006ab$var$ExcerptIncludeErrorComponent extends (0, $gwFzn.PureComponent) {
    render() {
        const { targetContentTitle: targetContentTitle, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'inline-block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                borderRadius: 5,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: 668,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 25,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                padding: "var(--ds-space-050, 4px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2p7B1))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                paddingLeft: "var(--ds-space-050, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                verticalAlign: 'text-bottom'
            }
        }, intl.formatMessage({
            id: "editor.excerpt.include.macro.error"
        }, {
            0: targetContentTitle
        })));
    }
}
const $6d5b4820d47006ab$export$9959a21ec1aff866 = (0, $js7oX.default)($6d5b4820d47006ab$var$ExcerptIncludeErrorComponent);

});

parcelRegister("47eY7", function(module, exports) {

$parcel$export(module.exports, "ExcerptIncludeQuery", () => $4f9132d1c9be1195$export$b23dd2d4faeb80fa);

var $d2LG0 = parcelRequire("d2LG0");
const $4f9132d1c9be1195$export$b23dd2d4faeb80fa = (0, $d2LG0.default)`query ExcerptIncludeQuery($contentId:ID!$macroNode:ExperimentalMacroNode!)@experimental{experimentalMacroMetadata(contentId:$contentId macroNode:$macroNode){payload contentId}}`;

});

parcelRegister("5TYcG", function(module, exports) {

$parcel$export(module.exports, "parseMacroOutputAdf", () => $6818d60359395137$export$9c17ec9416db96e4);
$parcel$export(module.exports, "getMacroId", () => $6818d60359395137$export$47eae2202f029f6b);
$parcel$export(module.exports, "getMacroParam", () => $6818d60359395137$export$a22f425ed063044b);
const $6818d60359395137$export$9c17ec9416db96e4 = (macroOutput)=>{
    try {
        if (macroOutput) {
            const parsed = JSON.parse(macroOutput);
            if (parsed.version === 1 && parsed.type === 'doc' && parsed.content) return parsed;
        }
    } catch (e) {
    // do nothing in case of parsing error, which would return `undefined`
    }
};
const $6818d60359395137$export$47eae2202f029f6b = (node)=>node?.parameters?.macroMetadata?.macroId?.value;
const $6818d60359395137$export$a22f425ed063044b = (node, name)=>node?.parameters?.macroParams?.[name]?.value;

});




//# sourceMappingURL=ExcerptInclude.780b83ca.js.map
